import { render, staticRenderFns } from "./billManagement.vue?vue&type=template&id=703ce8b4&scoped=true&"
import script from "./billManagement.vue?vue&type=script&lang=js&"
export * from "./billManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ce8b4",
  null
  
)

export default component.exports